
// src/connects/search-drawer.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import context from '../helpers/context'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { emitAlertMessage } from '../actions/alert-message'
import savedTempSearchQuery from '../actions/save-search-query-temp'
import find from 'lodash/find'
import filter from 'lodash/filter'
import { isSmartPhone } from '../helpers/agent-type'

export const mapStateToProps = (state, ownProps)=> {
  return {
    user: state.user.current,
    isFetching: state.preservedQueries.isFetching,
    preservedQueries: state.preservedQueries.items,
    isHome: ownProps.params && ownProps.params.group_id == 'home' || false, // スマホ版用
  }
}

const initialUIState = {
  group_id: 'home',
  queryText: '',
  category: 'all',
  liked_by: undefined,
  files_attached: false,
  users: undefined,
  reported_at: undefined,
  datePicker: false,
  deleteConfirm: false,
  deleteQueryName: undefined,
  deleteQuery: undefined,
  keyboardHeight: undefined,
}

/*
 * 検索条件の一時保存(savedTempSearchQuery)
 * 下記のようにグループ毎に検索条件が保存される
 *
 * [{"group_id":1,"queryText":"tem","category":"all"...
 * {"group_id":2,"queryText":"temddeede","category":"all"...
 * {"group_id":"home","queryText":"rlprfr","category":"all"...}]
 *
 */

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    willMount: (props)=> {
      const { group, updateUI, isHome} = props
      if(group && group.group_id || isHome){
        updateUI({group_id: isHome ? 'home' : group.group_id})
        savedTempSearchQuery.get((items) => {
          if(items){
            // 検索条件の一時保存 読み込み
            const groupSearchHistory = find(items, (_item) => isHome && _item.group_id == 'home' || _item.group_id == group.group_id)
            groupSearchHistory && updateUI(groupSearchHistory)
          }
        })
      }
      if(isSmartPhone){
        updateUI({ openSearchDrawer: true })
      }
    },
    willUpdate: (props, nextProps)=> {
      const { group, updateUI, active, isHome } = nextProps
      if (!props.active && active || !props.ui.openSearchDrawer && nextProps.ui.openSearchDrawer){
        dispatch(actions.fetchPreservedQueries(group && group.group_id != 'home' && !isHome && group.group_id || undefined))
        if(group && group.group_id || isHome){
          savedTempSearchQuery.get((items) => {
            // 検索条件の一時保存 読み込み
            const groupSearchHistory = isHome && find(items, (_item) => _item.group_id == 'home') || group && find(items, (_item) => _item.group_id == group.group_id)
            groupSearchHistory && updateUI(groupSearchHistory) || updateUI({group_id: isHome ? 'home' : group.group_id})
          })
        }
      }

      if (props.active && !active) {
        nextProps.updateUI(initialUIState)
      }
    },

    submitQuery: (props, ev)=> {
      const { onClose, ui, group, isHome, updateUI } = props
      ev && ev.preventDefault && ev.preventDefault()
      onClose && onClose()
      dispatch(actions.openRightSidePage('search_timeline', {
        category: ui.category,
        files_attached: ui.files_attached,
        liked_by: ui.liked_by,
        users: ui.users,
        reported_at: ui.reported_at,
        group_id: group && group.group_id != 'home' && !isHome && group.group_id || undefined,
        query: ui.queryText,
        isHome: isSmartPhone ? isHome : undefined
      }))
      if(group && group.group_id || isHome){
        savedTempSearchQuery.get((items) => {
          if(items){
            // 検索条件の一時保存 上書き処理
            const noChangeList = isHome && filter(items, (_item) => _item.group_id != 'home') || filter(items, (_item) => group && group.group_id !=_item.group_id)
            savedTempSearchQuery.set([...noChangeList, ui])
          } else {
            // 検索条件の一時保存 新規作成
            const initialFirstHistory = []
            savedTempSearchQuery.set([...initialFirstHistory, ui])
          }
        })
        updateUI(initialUIState)
      }
    },

    selectPreservedQuery: (props, query)=> {
      const { onClose, group, isHome, updateUI } = props
      onClose && onClose()
      dispatch(actions.openRightSidePage('search_timeline', isSmartPhone ? { query_id: query.query_id, isHome: isHome } : { query_id: query.query_id }))
      if(group && group.group_id || isHome) {
        const overWriteQuery = query && JSON.parse(query.query_text)
        const overWriteState = { 
          group_id:  (isHome || group.group_id == 'home') ? 'home' : query.group_id,
          queryText: overWriteQuery.queryText, 
          liked_by: overWriteQuery.liked_by, 
          category: overWriteQuery.category, 
          files_attached: overWriteQuery.files_attached, 
          users: query.users,
          reported_at: overWriteQuery.reported_at,
          datePicker: false,
          deleteConfirm: false,
          deleteQueryName: undefined,
          deleteQuery: undefined,
          keyboardHeight: undefined,
        }
        savedTempSearchQuery.get((items) => {
          if(items) {
            // 検索条件の上書き
            const noChangeList = isHome && filter(items, (_item) => _item.group_id != 'home') || filter(items, (_item) => group && group.group_id !=_item.group_id)
            savedTempSearchQuery.set([...noChangeList, overWriteState])
          }else {
            // 検索条件の一時保存 新規作成
            const initialFirstHistory = []
            savedTempSearchQuery.set([...initialFirstHistory, overWriteState])
          }
        })
        updateUI(initialUIState)
      }
    },
    deletePreservedQuery: (query, shouldClosePage)=> {
      dispatch(actions.deletePreservedQuery(query.query_id))
      shouldClosePage && dispatch(actions.closeRightSidePage()) //Webの場合、検索結果を開いた状態で削除を行うと検索結果内で再度条件の保存ができないため、サイドページを閉じるようにした
      dispatch(emitAlertMessage({ message: 'label:検索条件を削除しました', name: query.name }, 'topSuccess'))
    },
    clearSearchQuery: (props) => {
      const { ui, group, isHome, updateUI } = props
      updateUI(initialUIState)
      savedTempSearchQuery.get((items) => {
        if(items){
          // 検索条件の一時保存 削除処理
          const noChangeList = isHome && filter(items, (_item) => _item.group_id != 'home') || filter(items, (_item) => group && group.group_id !=_item.group_id)
          savedTempSearchQuery.set([...noChangeList])
        }
      })
    }
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: initialUIState,
  }),
  lifecycle,
  context({ showUserSelectionDialog: PropTypes.func }),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/search-drawer.js